import { createTheme } from '@mui/material/styles';
import type { PaletteOptions, Theme, ThemeOptions } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import { onboardingThemeOptions } from '@/theme/onboarding';
import type { TenantBrandingOverrides } from '@/types/branding';

function brandingToThemeOptions(branding: TenantBrandingOverrides): ThemeOptions {
  const palette: PaletteOptions = {};
  if (branding.primaryColor) {
    palette.primary = { main: branding.primaryColor };
  }
  if (branding.textColor) {
    palette.text = { primary: branding.textColor };
  }
  if (branding.backgroundColor) {
    palette.background = { default: branding.backgroundColor };
  }
  const progress: { active?: string; pending?: string } = {};
  if (branding.progressActiveColor) {
    progress.active = branding.progressActiveColor;
  }
  if (branding.progressPendingColor) {
    progress.pending = branding.progressPendingColor;
  }
  if (progress.active !== undefined || progress.pending !== undefined) {
    palette.progress = progress;
  }
  if (branding.badgeBackground) {
    palette.badge = { background: branding.badgeBackground };
  }
  return { palette };
}

export function createOnboardingTheme(branding?: TenantBrandingOverrides): Theme {
  if (!branding) {
    return createTheme(onboardingThemeOptions);
  }
  return createTheme(deepmerge(onboardingThemeOptions, brandingToThemeOptions(branding)));
}

export const theme = createOnboardingTheme();
